import {getMessages} from 'app/store/constants';

export const TEMPLATE_SECTION_TITLE = getMessages().getText('board_settings.actions.create_template');
